export default __webpack_public_path__ + "static/media/Curl-logo.57de3d9c.svg";